import { supabase } from './supabase';

// Talks to the secure server-side "admin-api" Edge Function.
// The logged-in user's session is attached automatically by Supabase; the
// function verifies the caller is an admin before doing anything privileged.
// No service/master key is ever used or stored in the browser.
async function callAdmin(action, payload) {
  const { data, error } = await supabase.functions.invoke('admin-api', {
    body: { action, payload },
  });

  if (error) {
    // Surface the function's own error message when available.
    let msg = error.message || 'Request failed';
    try {
      const ctx = error.context && error.context.json ? await error.context.json() : null;
      if (ctx && ctx.error) msg = ctx.error;
    } catch (_) { /* ignore */ }
    throw new Error(msg);
  }
  if (data && data.error) throw new Error(data.error);
  return data;
}

// Create a new login account. Returns the new auth user (includes .id).
export async function adminCreateUser({ email, password, full_name }) {
  const data = await callAdmin('create_user', { email, password, full_name });
  return data.user;
}

// Update an existing login account (e.g. reset password). Returns the auth user.
export async function adminUpdateUser(id, fields) {
  const data = await callAdmin('update_user', { id, ...fields });
  return data.user;
}

// Look up a login account by email. Returns the auth user, or null if none.
export async function adminFindUserByEmail(email) {
  const data = await callAdmin('find_user_by_email', { email });
  return data.user;
}
